import classnames from "classnames";
import React, { useEffect, useState } from "react";
import { getSolutionContactDetails } from "../../utils/data/getContactDetails";
import HelpItemDamagedOnDelivery from "../contact-us-delivery-solution/helpItemDamagedOnDelivery/HelpItemDamagedOnDelivery";
import SlideIn from "@/components/slide-in/SlideIn";
import ContactDetailsBox from "@/components/contact-details-box/ContactDetailsBox";

import styles from "./contact-us-standard-expanded-solution.module.scss";

function ContactUsStandardExpandedSolution({ solution: { id, hierarchyPosition }, className }) {
  const getSolutionComponent = solutionID => {
    switch (solutionID) {
      case "itemDamagedOnDelivery":
        return HelpItemDamagedOnDelivery;
      default:
        return null;
    }
  };
  const [liveChatConfig, setLiveChatConfig] = useState(null);
  const SolutionComponent = getSolutionComponent(id);
  const location = hierarchyPosition.join(" | ");

  useEffect(() => {
    getSolutionContactDetails(location).then(config => {
      setLiveChatConfig(config.chat);
    });
  }, []);

  const contactFields = [
    { name: "email", key: "email" },
    { name: "chat", key: "channel" },
  ];

  return (
    <article className={classnames(styles.standardSolution, className)} data-solution-id={id}>
      <h2 className={styles.standardSolution__top}>Did you know</h2>
      <div className={styles.standardSolution__inner} data-test="solution-inner">
        <SolutionComponent />
        <SlideIn>
          <ContactDetailsBox
            title="We’re here to help"
            fields={contactFields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
            solutionId={liveChatConfig?.solution}
            location={location}
            otherContactDetails={liveChatConfig?.chat}
            viewContactDetails
            showGreyBackground
            showEmailOption={false}
            showContactDetailsByDefault
          />
        </SlideIn>
      </div>
    </article>
  );
}

export default ContactUsStandardExpandedSolution;
